import { Page } from '@app/components/page/Page';
import { StationIcon } from '@app/components/stations/StationIcon';
import { useStations } from '@app/core/stations/hooks/useStations';
import { useIntl } from 'react-intl';
import { AdminModule } from '../../../index';
import { AdminStationsList } from './AdminStationsList';

export const AdminStationsListPage = () => {
  const { $t } = useIntl();
  const stations = useStations();
  const title = $t({
    id: 'admin.stations.listScreen.title',
    defaultMessage: 'Emisoras',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<StationIcon />}
        title={title}
        breadcrumbs={<Page.ModuleBreadcrumbs module={AdminModule} />}
      />
      <Page.Content>
        <AdminStationsList data={stations} />
      </Page.Content>
    </Page>
  );
};
